import {HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';


// URL LOCALHOST
export const API_URL = location.protocol + '//' + location.hostname + '/coc-rest/coc';
// URL LOCALHOST
export const LOCALHOST_URL = location.protocol + '//' + location.hostname;

// URL QA
// export const API_URL = 'https://safetender-qa-admin.omnikles.com/tenderlink-rest';

export const HTTP_OPTION = {
  headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'})
};

export const HTTP_OPTION_URLENCODED = {
  headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'})
};

export const HTTP_OPTION_PUT = {
  headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}),
  params: new HttpParams()
};


export const HTTP_OPTION_PARAMS = {
  headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'}),
  params: new HttpParams()
};

export const HTTP_OPTION_MULTIPART = {
  headers: new HttpHeaders({'Content-Type': 'multipart/form-data'}),
  params: new HttpParams()
};

@Injectable()
export class AppConfigService {

  loadConfig(): Promise<void> {
    return Promise.resolve(undefined);
  }
}
